import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { Home } from "./components/home/home";
import { Nav } from "./components/nav/nav";
import { Footer } from "./components/footer/footer";
import { About } from "./pages/about/about";
import { BookNow } from "./pages/booknow/booknow";
import { Gallery } from "./pages/gallery/gallery";
import Rooms from "./pages/rooms/rooms";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/booknow" element={<BookNow />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/rooms" element={<Rooms />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
